export default __webpack_public_path__ + "static/media/solution.666223a3.svg";